import validate from "C:/Users/HP/WebstormProjects/EMCI/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "C:/Users/HP/WebstormProjects/EMCI/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  cors: () => import("C:/Users/HP/WebstormProjects/EMCI/middleware/cors.js")
}